import classNames from "classnames";
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  const classes = classNames(className, "w-20");
  return (
    <Link to="/">
      <img
        alt="logo"
        src="/assets/logos/logo.png"
        className={classes}
      />
    </Link>
  );
};

export default Logo;
